import { beforeStart, onError } from './configure-app'
import { startApp } from './start-app'

startApp({
  beforeStart,
  onError,
})
